import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { GroupDuesDto, ResponseDto } from "@mimber/schema"
import { groupDuesKeys } from "../groups.utils"

/**
 * Hook for fetching a group's dues config, active member count, and
 * estimated periodic revenue.
 * Can only be used in mimber-organization app.
 */
export const useGroupDues = (
  groupUuid: string,
  options?: UseQueryOptions<ResponseDto<GroupDuesDto>, Error>
): UseQueryResult<ResponseDto<GroupDuesDto>, Error> => {
  guardAppUsage("mimber-organization", "useGroupDues")

  const { server } = useServerContext()

  return useQuery({
    queryKey: groupDuesKeys.getDues(groupUuid),
    queryFn: async () => {
      const response = await server.get<ResponseDto<GroupDuesDto>>(
        `groups/${groupUuid}/dues`
      )
      return response.data
    },
    enabled: !!groupUuid, // Only run query if groupUuid is provided
    ...options,
  })
}
